import { render, staticRenderFns } from "./addMeiTuanServant.vue?vue&type=template&id=78c718a6&scoped=true"
import script from "./addMeiTuanServant.vue?vue&type=script&lang=js"
export * from "./addMeiTuanServant.vue?vue&type=script&lang=js"
import style0 from "./addMeiTuanServant.vue?vue&type=style&index=0&id=78c718a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c718a6",
  null
  
)

export default component.exports